function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#4B4B4B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  transform: "translate(3 3)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 9
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.267 8.6c0 1.423-.794 2.683-1.634 3.453v.747c0 .467.234 1.19 2.567 1.633.896.172 1.563.534 2.001 1.087C13.524 17.173 11.457 18 9 18c-2.457 0-4.574-.873-6.35-2.62.401-.484 1.04-.8 1.917-.947 2.333-.42 2.8-1.166 2.8-1.633v-.747c-.84-.77-1.634-2.006-1.634-3.453V6.36C5.733 3.933 7.46 3 9 3c1.54 0 3.267.933 3.267 3.36V8.6z"
}));

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.be58fb93.svg";
export { ForwardRef as ReactComponent };